import type { ReactNode } from 'react';
import { cn } from '@shared/utils/utils';

interface ConfigurationPageHeaderProps {
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
}

/**
 * Cabecera de página de Configuration.
 * El botón de acción queda centrado verticalmente respecto al bloque título + subtítulo.
 */
export function ConfigurationPageHeader({ title, description, action, className }: ConfigurationPageHeaderProps) {
  return (
    <div className={cn('flex justify-between gap-4', className)}>
      <div className="min-w-0">
        <h1 className="text-2xl font-semibold tracking-tight text-foreground">{title}</h1>
        {description ? <p className="mt-1 text-sm text-muted-foreground">{description}</p> : null}
      </div>
      {action ? <div className="flex shrink-0 items-center">{action}</div> : null}
    </div>
  );
}
